import { render, staticRenderFns } from "./EmiratisationStatistics.vue?vue&type=template&id=c272c078&scoped=true&"
import script from "./EmiratisationStatistics.vue?vue&type=script&lang=ts&"
export * from "./EmiratisationStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./EmiratisationStatistics.vue?vue&type=style&index=0&id=c272c078&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c272c078",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCol,VIcon,VRow})
